export type UserIdType = string
export const UserIdCtor = String
